module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RECOLLECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-1"
  }, [_c('b', [_c('i', [_vm._v("of Early Texas")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-1",
    attrs: {
      "id": "a2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/map1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcap"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPUBLIC OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXAS.")]), _vm._v(" "), _c('i', [_vm._v("From Stanley Siegel,")]), _vm._v(" A Political History of the Texas Republic, 1836–1845, "), _c('i', [_vm._v("1956")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415106b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292749375_12_htit1.vue
// module id = 90
// module chunks = 0